import './styles/app.css';

import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import React, { useState } from "react"; // <-- importer useState
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword.js';
import CGU from './pages/CGU';
import CGV from './pages/CGV';
import Login from './pages/Login';
import Store from './pages/Store.js';
import ProductDetails from './pages/ProductDetails.js';
import Cart from './pages/Cart.js';
import Checkout from './pages/Checkout.js';
import Confirmation from './pages/Confirmation.js';
import SignupStep1 from './pages/SignupStep1';
import SignupStep2 from './pages/SignupStep2';
import { AuthProvider, useAuth } from './context/AuthContext.js';
import { CartProvider } from './context/CartContext'; // Import your CartProvider
import logo_titre from "./assets/logo-titre-header.png"; // adapte le chemin à ton projet


function App() {
  return (
    <AuthProvider>
            <CartProvider>
              <AppContent />
            </CartProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false); // <-- déclarer l'état


  const { isAuthenticated, logout, loading } = useAuth(); // ✅ récupérer loading

  if (loading) {
    // Affiche un loader pendant la vérification du token
    return (
      <div className="loading-screen">
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="App">
     <header className="App-header">
      <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="nav-link">
            <img src={logo_titre} alt="Gioco Mortale" className="App-logo" />
          </Link>
        </div>

        {/* Bouton burger pour mobile */}
        <button
          className="burger-button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          &#9776; {/* icône burger simple */}
        </button>

        <div className={`nav-right ${menuOpen ? 'open' : ''}`}>
          <Link to="/store" className="nav-link">Acheter une Murder Party</Link>
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
              <button
                onClick={() => { logout();  navigate("/");}}
                className="nav-link"
              >
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Connexion</Link>
              <Link to="/signup" className="nav-link">S'inscrire</Link>
            </>
          )}
        </div>
      </div>
    </header>



      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup" element={<SignupStep1 />} />
          <Route path="/signup/step2" element={<SignupStep2 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/admin" element={<Home />} />
          <Route path="/store" element={<Store />} />
          <Route path="/store/:productId" element={<ProductDetails />} /> {/* C'est la route dynamique ! */}
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} />

          <Route path="/comment-organiser-une-murder-party-chez-soi-guide-etape-par-etape" element={<Home />} />
          <Route path="/acheter" element={<Home />} />
          <Route path="/jouer" element={<Home />} />
          <Route path="/cgu-cgv" element={<CGU />} />
          <Route path="/mon-compte" element={<Home />} />

        </Routes>
      </main>

      <Footer />
    </div>
  );
}


export default App;
